import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Wspólne (powłoka): nawigacja, menu boczne, przełącznik języka.
import commonPl from './locales/pl.json';
import commonEn from './locales/en.json';
import commonDe from './locales/de.json';

// --- Namespace'y marketingowe (faza 2) ---
import landingPl from './locales/pl/landing.json';
import landingEn from './locales/en/landing.json';
import landingDe from './locales/de/landing.json';
import footerPl from './locales/pl/footer.json';
import footerEn from './locales/en/footer.json';
import footerDe from './locales/de/footer.json';
import pricingPl from './locales/pl/pricing.json';
import pricingEn from './locales/en/pricing.json';
import pricingDe from './locales/de/pricing.json';
import featuresPl from './locales/pl/features.json';
import featuresEn from './locales/en/features.json';
import featuresDe from './locales/de/features.json';
import comparisonPl from './locales/pl/comparison.json';
import comparisonEn from './locales/en/comparison.json';
import comparisonDe from './locales/de/comparison.json';
import termsPl from './locales/pl/terms.json';
import termsEn from './locales/en/terms.json';
import termsDe from './locales/de/terms.json';
import privacyPl from './locales/pl/privacy.json';
import privacyEn from './locales/en/privacy.json';
import privacyDe from './locales/de/privacy.json';
import contactPl from './locales/pl/contact.json';
import contactEn from './locales/en/contact.json';
import contactDe from './locales/de/contact.json';
import authPl from './locales/pl/auth.json';
import authEn from './locales/en/auth.json';
import authDe from './locales/de/auth.json';
import notFoundPl from './locales/pl/notFound.json';
import notFoundEn from './locales/en/notFound.json';
import notFoundDe from './locales/de/notFound.json';
import blogPl from './locales/pl/blog.json';
import blogEn from './locales/en/blog.json';
import blogDe from './locales/de/blog.json';
import ebooksPl from './locales/pl/ebooks.json';
import ebooksEn from './locales/en/ebooks.json';
import ebooksDe from './locales/de/ebooks.json';
import guidesPublicPl from './locales/pl/guidesPublic.json';
import guidesPublicEn from './locales/en/guidesPublic.json';
import guidesPublicDe from './locales/de/guidesPublic.json';

// --- Namespace'y panelu (faza 3) ---
import dashboardPl from './locales/pl/dashboard.json';
import dashboardEn from './locales/en/dashboard.json';
import dashboardDe from './locales/de/dashboard.json';
import campaignsPl from './locales/pl/campaigns.json';
import campaignsEn from './locales/en/campaigns.json';
import campaignsDe from './locales/de/campaigns.json';
import campaignDraftPl from './locales/pl/campaignDraft.json';
import campaignDraftEn from './locales/en/campaignDraft.json';
import campaignDraftDe from './locales/de/campaignDraft.json';
import campaignWizardPl from './locales/pl/campaignWizard.json';
import campaignWizardEn from './locales/en/campaignWizard.json';
import campaignWizardDe from './locales/de/campaignWizard.json';
import campaignEditPl from './locales/pl/campaignEdit.json';
import campaignEditEn from './locales/en/campaignEdit.json';
import campaignEditDe from './locales/de/campaignEdit.json';
import settingsPl from './locales/pl/settings.json';
import settingsEn from './locales/en/settings.json';
import settingsDe from './locales/de/settings.json';
import suggestionsPl from './locales/pl/suggestions.json';
import suggestionsEn from './locales/en/suggestions.json';
import suggestionsDe from './locales/de/suggestions.json';
import agencyPl from './locales/pl/agency.json';
import agencyEn from './locales/en/agency.json';
import agencyDe from './locales/de/agency.json';
import shoppingPl from './locales/pl/shopping.json';
import shoppingEn from './locales/en/shopping.json';
import shoppingDe from './locales/de/shopping.json';
import testShopsPl from './locales/pl/testShops.json';
import testShopsEn from './locales/en/testShops.json';
import testShopsDe from './locales/de/testShops.json';
import activityPl from './locales/pl/activity.json';
import activityEn from './locales/en/activity.json';
import activityDe from './locales/de/activity.json';
import budgetPlannerPl from './locales/pl/budgetPlanner.json';
import budgetPlannerEn from './locales/en/budgetPlanner.json';
import budgetPlannerDe from './locales/de/budgetPlanner.json';
import insightsPanelPl from './locales/pl/insightsPanel.json';
import insightsPanelEn from './locales/en/insightsPanel.json';
import insightsPanelDe from './locales/de/insightsPanel.json';
import guidesPanelPl from './locales/pl/guidesPanel.json';
import guidesPanelEn from './locales/en/guidesPanel.json';
import guidesPanelDe from './locales/de/guidesPanel.json';
import conversionsPl from './locales/pl/conversions.json';
import conversionsEn from './locales/en/conversions.json';
import conversionsDe from './locales/de/conversions.json';
import shellPl from './locales/pl/shell.json';
import shellEn from './locales/en/shell.json';
import shellDe from './locales/de/shell.json';

// Droid jest produktem polskim - polski jest domyślny (fallback). Angielski i niemiecki
// są dodatkowymi wersjami, wybieraną przez użytkownika (zapis w localStorage 'droid_lang')
// lub wykrywaną z języka przeglądarki.
export const SUPPORTED_LANGS = ['pl', 'en', 'de'];

// Każdy plik namespace ma kształt { "<ns>": { ... } }, więc scalają się przez
// Object.assign w jeden słownik 'translation' o rozłącznych kluczach najwyższego poziomu.
const pl = Object.assign({}, commonPl,
  landingPl, footerPl, pricingPl, featuresPl, comparisonPl, termsPl, privacyPl,
  contactPl, authPl, notFoundPl, blogPl, ebooksPl, guidesPublicPl,
  dashboardPl, campaignsPl, campaignDraftPl, campaignWizardPl, campaignEditPl,
  settingsPl, suggestionsPl, agencyPl, shoppingPl, testShopsPl, activityPl,
  budgetPlannerPl, insightsPanelPl, guidesPanelPl, conversionsPl, shellPl);
const en = Object.assign({}, commonEn,
  landingEn, footerEn, pricingEn, featuresEn, comparisonEn, termsEn, privacyEn,
  contactEn, authEn, notFoundEn, blogEn, ebooksEn, guidesPublicEn,
  dashboardEn, campaignsEn, campaignDraftEn, campaignWizardEn, campaignEditEn,
  settingsEn, suggestionsEn, agencyEn, shoppingEn, testShopsEn, activityEn,
  budgetPlannerEn, insightsPanelEn, guidesPanelEn, conversionsEn, shellEn);
const de = Object.assign({}, commonDe,
  landingDe, footerDe, pricingDe, featuresDe, comparisonDe, termsDe, privacyDe,
  contactDe, authDe, notFoundDe, blogDe, ebooksDe, guidesPublicDe,
  dashboardDe, campaignsDe, campaignDraftDe, campaignWizardDe, campaignEditDe,
  settingsDe, suggestionsDe, agencyDe, shoppingDe, testShopsDe, activityDe,
  budgetPlannerDe, insightsPanelDe, guidesPanelDe, conversionsDe, shellDe);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translation: pl },
      en: { translation: en },
      de: { translation: de },
    },
    fallbackLng: 'pl',
    supportedLngs: SUPPORTED_LANGS,
    // 'en-US' -> 'en' itd., żeby wariacje regionalne mapowały się na obsługiwany język.
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
      // {{cur}} = symbol waluty KONTA reklamowego (campaign.currency / stats.currency).
      // Wywołania, które jeszcze nie przekazują `cur`, dostają domyślnie „zł".
      defaultVariables: { cur: 'zł' },
    },
    returnObjects: true,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'droid_lang',
      caches: ['localStorage'],
    },
  });

// <html lang> zgodny z wybranym językiem (inaczej przeglądarka przy DE/EN proponuje
// „przetłumacz z polskiego").
const syncHtmlLang = (lng) => {
  if (typeof document !== 'undefined') document.documentElement.lang = (lng || 'pl').slice(0, 2);
};
syncHtmlLang(i18n.resolvedLanguage || i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
